module.exports = __webpack_public_path__ + "static/media/Xemelgo-Logomark.c4087f34.png";